const categoryDropdown = document.getElementById("nutrition-options-1");
const subcategoryDropdown = document.getElementById("nutrition-options-2");
const sections = document.querySelectorAll("#sections .sectioncard");
const resetButton = document.getElementById("reset-button");

// Show all sections by default
sections.forEach((section) => (section.style.display = "block"));

categoryDropdown.addEventListener("change", () => {
  const selectedCategory = categoryDropdown.value;

  // Show only options matching the selected category in the second dropdown
  Array.from(subcategoryDropdown.options).forEach((option) => {
    if (option.dataset.category === selectedCategory || option.value === "") {
      option.style.display = "block";
    } else {
      option.style.display = "none";
    }
  });

  // Reset second dropdown and show all sections if no category is selected
  subcategoryDropdown.value = "";
  if (!selectedCategory) {
    sections.forEach((section) => (section.style.display = "block"));
  } else {
    sections.forEach((section) => (section.style.display = "none"));
  }
});

subcategoryDropdown.addEventListener("change", () => {
  const selectedSubcategory = subcategoryDropdown.value;

  // Show all sections if no subcategory is selected
  if (!selectedSubcategory) {
    sections.forEach((section) => (section.style.display = "block"));
  } else {
    // Hide all sections and show only the selected one
    sections.forEach((section) => {
      if (section.dataset.option === selectedSubcategory) {
        section.style.display = "block";
      } else {
        section.style.display = "none";
      }
    });
  }
});

resetButton.addEventListener("click", () => {
  // Reset dropdowns
  categoryDropdown.value = "";
  subcategoryDropdown.value = "";

  // Show all dropdown options
  Array.from(subcategoryDropdown.options).forEach((option) => {
    option.style.display = "block";
  });

  // Show all sections
  sections.forEach((section) => (section.style.display = "block"));
});
